// @ts-ignore
import {Component} from '@angular/core';
// @ts-ignore
import {RouterOutlet} from '@angular/router';

// @ts-ignore
@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet],
    template: '<router-outlet></router-outlet>'
})
export class AppComponent {
}
